import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Home';

import TermsOfUs from './TermsOfUs';
import PrivacyPolicy from './PrivacyPolicy';
import AccessibilityStatement from './AccessibilityStatement';

import { BrowserRouter, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>

  <Routes>
  <Route path="/" element={<Home />} />
        <Route path="/termsOfUse" element={<TermsOfUs/>} />
        <Route path="/termsOfUs" element={<TermsOfUs/>} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy/>} />
        <Route path="/accessibilityStatement" element={<AccessibilityStatement/>} />
      </Routes>
  </BrowserRouter>
);
